import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertCounsellorsListDetails } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface insertCounsellorsListDetailsState {
  insertCounsellorsListDetails: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: insertCounsellorsListDetailsState = {
  insertCounsellorsListDetails: [],
  status: "idle",
};

export const GetinsertCounsellorsListDetails = createAsyncThunk(
  "insertCounsellorsListDetails",
  async (data: any) => {
    const response = await fetchInsertCounsellorsListDetails(data);
    return response;
  }
);

export const insertCounsellorsListDetailsSlice = createSlice({
  name: "insertCounsellorsListDetails",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetinsertCounsellorsListDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetinsertCounsellorsListDetails.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetinsertCounsellorsListDetails.fulfilled, (state, action) => {
        state.status = "success";
        state.insertCounsellorsListDetails = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = insertCounsellorsListDetailsSlice.actions;

export const selectinsertCounsellorsListDetails = (state: RootState) => {
  return state.InsertCounsellorsListDetails.insertCounsellorsListDetails;
};

export default insertCounsellorsListDetailsSlice.reducer;
